import React from "react";
import {Button, Col, Row} from "reactstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPencil} from "@fortawesome/free-solid-svg-icons";
import SettingDisplay from "./settingDisplay";
import SettingEditor from "./settingEditor";


export default function Setting({data}) {
    const [editMode, setEditMode] = React.useState(false);

    return (
        <Row className="border-bottom p-3">
            <Col>
                <p><code>{data.key}</code></p>
                {
                    editMode ?
                        <SettingEditor data={data} toggleEditMode={() => setEditMode(!editMode)}/> :
                        <SettingDisplay settingType={data.setting_type} value={data.value}/>
                }

            </Col>
            {
                !editMode && <Col sm={1}>
                    <Button onClick={() => setEditMode(!editMode)} color="link" size="sm">
                        <FontAwesomeIcon icon={faPencil}/>
                    </Button>
                </Col>
            }

        </Row>
    )
}